/**
 * Log severity levels, ordered from highest to lowest priority.
 * When diagnostic mode is OFF only INFO and above are persisted.
 * When diagnostic mode is ON all levels including DEBUG are persisted.
 */
export type LogLevel = 'ERROR' | 'WARN' | 'INFO' | 'DEBUG';

/**
 * Structured context attached to a log entry.
 */
export type LogContext = Record<string, unknown>;

export const LogCategory = {
    APP_LIFECYCLE: 'app.lifecycle',
    AUTH: 'auth',
    NAVIGATION: 'navigation',
    STORAGE: 'storage',
    NETWORK: 'network',
    DIAGNOSTICS: 'diagnostics',
} as const;

export type LogCategory = (typeof LogCategory)[keyof typeof LogCategory];

/**
 * A single persisted log entry.
 */
export interface LogEntry {
    id?: number;
    timestamp: string;
    level: LogLevel;
    category: LogCategory;
    event: string;
    context: LogContext;
    message?: string;
    sessionId?: string;
    logSessionId?: string;
    diagnosticMode?: boolean;
}

export interface LogWriteOptions {
    sessionId?: string;
    logSessionId?: string;
}

